import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import Login from "./pages/Login";
import ProjectsList from "./pages/ProjectsList";
import MeetingsList from "./pages/MeetingsList";
import UsersList from "./pages/UsersList";
import ProtectedRoute from "./components/ProtectedRoute";
import MeetingParticipationReport from "./components/MeetingParticipationReport";
import MeetingFollowup from "./pages/MeetingFollowup";

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/projects"
          element={
            <ProtectedRoute>
              <ProjectsList />
            </ProtectedRoute>
          }
        />
        <Route
          path="/meetings"
          element={
            <ProtectedRoute>
              <MeetingsList />
            </ProtectedRoute>
          }
        />
        <Route
          path="/users"
          element={
            <ProtectedRoute>
              <UsersList />
            </ProtectedRoute>
          }
        />
        <Route path="/report" element={<MeetingParticipationReport />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/meeting-followup" element={<MeetingFollowup />} />
      </Routes>
    </Router>
  );
};

export default App;
